// extracted by mini-css-extract-plugin
module.exports = {"form":"NewShelveDialog__form"};